module.exports = __webpack_public_path__ + "a850c02c2736d25b97bf6d8bf6cac2b1.png";